import React from 'react';

class LampIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_254_1546)">
          <g filter="url(#filter0_d_254_1546)">
            <path
              d="M35.9856 4.1001L26.0136 40.0001H16.9116C15.7936 40.0001 15.0196 38.9221 15.4136 37.9121L28.2096 5.1001C28.4436 4.4981 29.0416 4.1001 29.7076 4.1001H35.9856Z"
              fill="url(#paint0_linear_254_1546)"
            />
            <path
              d="M39.9997 4.1001V40.0001H26.0137L35.9857 4.1001H39.9997Z"
              fill="url(#paint1_linear_254_1546)"
            />
            <path
              d="M53.986 40.0001H40V4.1001H44.014L53.986 40.0001Z"
              fill="url(#paint2_linear_254_1546)"
            />
            <path
              d="M63.0877 40.0001H53.9857L44.0137 4.1001H50.2917C50.9577 4.1001 51.5557 4.4981 51.7897 5.1001L64.5856 37.9121C64.9796 38.9221 64.2056 40.0001 63.0877 40.0001Z"
              fill="url(#paint3_linear_254_1546)"
            />
            <path d="M43.3996 40H36.5996V69.6H43.3996V40Z" fill="#F7F4F1" />
            <path
              d="M24.4 69.6001H55.6C56.924 69.6001 58 70.6761 58 72.0001V76.0001H22V72.0001C22 70.6761 23.076 69.6001 24.4 69.6001Z"
              fill="#E0DDDA"
            />
            <path
              d="M55.5099 44.1361C55.5099 43.2712 54.8092 42.5701 53.9449 42.5701C53.0806 42.5701 52.3799 43.2712 52.3799 44.1361V46.0121C52.3799 46.8769 53.0806 47.5781 53.9449 47.5781C54.8092 47.5781 55.5099 46.8769 55.5099 46.0121V44.1361Z"
              fill="#F7F4F1"
            />
            <path
              d="M55.5099 51.7161C55.5099 50.8513 54.8092 50.1501 53.9449 50.1501C53.0806 50.1501 52.3799 50.8513 52.3799 51.7161V53.5921C52.3799 54.457 53.0806 55.1581 53.9449 55.1581C54.8092 55.1581 55.5099 54.457 55.5099 53.5921V51.7161Z"
              fill="#F7F4F1"
            />
            <path
              d="M65.3316 37.62L52.5356 4.81005C52.1856 3.90605 51.2836 3.30005 50.2916 3.30005H29.7076C28.7156 3.30005 27.8156 3.90605 27.4636 4.81005L14.6676 37.622C14.3916 38.33 14.4836 39.128 14.9136 39.758C15.3596 40.412 16.1076 40.802 16.9116 40.802H35.7996V68.802H24.3996C22.6356 68.802 21.1996 70.238 21.1996 72.002V76.002C21.1996 76.444 21.5576 76.802 21.9996 76.802H57.9996C58.4416 76.802 58.7996 76.444 58.7996 76.002V72.002C58.7996 70.238 57.3636 68.802 55.5996 68.802H44.1996V40.8H63.0876C63.8916 40.8 64.6376 40.41 65.0856 39.756C65.5156 39.126 65.6076 38.328 65.3316 37.62ZM40.7996 40.8H42.5996V68.8H37.3996V40.8H40.7996ZM25.4056 39.2H16.9116C16.6316 39.2 16.3856 39.074 16.2356 38.854C16.1576 38.738 16.0416 38.502 16.1596 38.202L28.9556 5.39005C29.0696 5.09805 29.3716 4.90005 29.7076 4.90005H34.9336L30.1696 22.05L25.4056 39.2ZM27.0656 39.2L31.8296 22.05L36.5936 4.90005H39.1996V39.2H27.0656ZM55.5996 70.4C56.4816 70.4 57.1996 71.118 57.1996 72V75.2H22.7996V72C22.7996 71.118 23.5176 70.4 24.3996 70.4H55.5996ZM43.3996 39.2H40.7996V4.90005H43.4056L48.1696 22.05L52.9336 39.2H43.3996ZM63.7636 38.854C63.6136 39.074 63.3676 39.2 63.0876 39.2H54.5936L49.8296 22.05L45.0656 4.90005H50.2916C50.6276 4.90005 50.9296 5.09605 51.0436 5.39005L63.8396 38.202C63.9556 38.5 63.8396 38.738 63.7636 38.854Z"
              fill="#84827E"
            />
            <path
              d="M56.3091 44.136C56.3091 42.832 55.2471 41.77 53.9431 41.77C52.6391 41.77 51.5771 42.832 51.5771 44.136V46.014C51.5771 47.318 52.6391 48.38 53.9431 48.38C55.2471 48.38 56.3091 47.318 56.3091 46.014V44.136ZM54.7091 46.014C54.7091 46.436 54.3651 46.78 53.9431 46.78C53.5211 46.78 53.1771 46.436 53.1771 46.014V44.136C53.1771 43.714 53.5211 43.37 53.9431 43.37C54.3651 43.37 54.7091 43.714 54.7091 44.136V46.014Z"
              fill="#84827E"
            />
            <path
              d="M56.3091 51.7161C56.3091 50.4121 55.2471 49.3501 53.9431 49.3501C52.6391 49.3501 51.5771 50.4121 51.5771 51.7161V53.5941C51.5771 54.8981 52.6391 55.9601 53.9431 55.9601C55.2471 55.9601 56.3091 54.8981 56.3091 53.5941V51.7161ZM54.7091 53.5941C54.7091 54.0161 54.3651 54.3601 53.9431 54.3601C53.5211 54.3601 53.1771 54.0161 53.1771 53.5941V51.7161C53.1771 51.2941 53.5211 50.9501 53.9431 50.9501C54.3651 50.9501 54.7091 51.2941 54.7091 51.7161V53.5941Z"
              fill="#84827E"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_254_1546"
            x="13.1107"
            y="1.90005"
            width="56.9775"
            height="79.502"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_254_1546"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_254_1546"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_254_1546"
            x1="18.2177"
            y1="7.31107"
            x2="40.8442"
            y2="22.2588"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_254_1546"
            x1="27.9808"
            y1="7.31107"
            x2="46.3064"
            y2="15.5003"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_254_1546"
            x1="41.9671"
            y1="7.31107"
            x2="60.2927"
            y2="15.5003"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_254_1546"
            x1="46.9218"
            y1="7.31107"
            x2="69.5483"
            y2="22.2588"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_254_1546">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default LampIcon;
